import { render, staticRenderFns } from "./cpePolicy.vue?vue&type=template&id=ea8697be&scoped=true&"
import script from "./cpePolicy.vue?vue&type=script&lang=js&"
export * from "./cpePolicy.vue?vue&type=script&lang=js&"
import style0 from "./cpePolicy.vue?vue&type=style&index=0&id=ea8697be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8697be",
  null
  
)

export default component.exports